import { render, staticRenderFns } from "./tc-layers.vue?vue&type=template&id=0c88ee22&"
import script from "./tc-layers.vue?vue&type=script&lang=js&"
export * from "./tc-layers.vue?vue&type=script&lang=js&"
import style0 from "./tc-layers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports